import fetchRetry from 'fetch-retry-ts';

// Create a fetch instance with 5 retries
export const fetchWithRetry = fetchRetry(fetch, {
  retries: 5,
  retryDelay: (attempt: number, error: Error | null, response: Response | null) => Math.pow(2, attempt) * 1000, // Exponential backoff: 1s, 2s, 4s, 8s, 16s
  retryOn: (attempt: number, retries: number, error: Error | null, response: Response | null) => {
    // Retry on network errors
    if (error !== null) {
      return true;
    }
    
    // Retry on 5xx errors or 429 (rate limit)
    if (response && (response.status >= 500 || response.status === 429)) {
      return true;
    }
    
    // Don't retry on 4xx errors (except 429)
    return false;
  }
});

// Export as default for easy importing
export default fetchWithRetry;